import qs from 'qs';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint } from 'lib/interfaces/api';
import { JsonSchema } from 'lib/json-schema';

export const casesApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    resolveCaseVariable: builder.query<
      any[],
      { caseToken: string; variableDefinitionToken: string; variableMap?: Record<string, any> }
    >({
      query: async ({ caseToken, variableDefinitionToken, variableMap }) => {
        return SessionClientDashboard.get<JsonSchema>(
          ApiEndpoint.Case,
          caseToken,
          `resolve-variable?${qs.stringify({
            'variable-definition-token': variableDefinitionToken,
            'variable-map': JSON.stringify(variableMap),
          })}`,
        );
      },
      // Since contextAdapters use 'useQueryState' which doesn't maintain subscriptions, and only the last query
      // in useCaseDataContext gets subscribed to, we set keepUnusedDataFor to max to prevent data from being removed from cache
      keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
      // omit the variableMap from the query args so modules can fetch without recomputing variable dependencies
      serializeQueryArgs: ({ queryArgs }) => {
        const { variableMap, ...otherArgs } = queryArgs;

        return {
          ...otherArgs,
        };
      },
    }),
  }),
});

export const {
  useLazyResolveCaseVariableQuery,
  useResolveCaseVariableQuery,
  endpoints: {
    resolveCaseVariable: { useQueryState: useResolveCaseVariableQueryState },
  },
} = casesApi;
